import { MovingGradient } from '../../../../components/MovingGradient';
import FlexGrid from '../../../../components/FlexGrid';
import { isMobile } from '../../../../utils/device';
import { getRandomBoundary } from '../../../list/listPage/ListLoadingPlaceholder/utils';

export const DetailPageHeaderTitlePlaceholder = () => {
	return (
		<section
			style={{
				alignItems: 'center',
				display: 'flex',
				minHeight: '48px',
				minWidth: '248px',
			}}
			data-testid='headerTitle'
		>
			<div
				style={{
					display: 'flex',
					flex: '1 1 auto',
					flexDirection: 'column',
					justifyContent: 'space-between',
					minWidth: '1px',
				}}
			>
				<h2
					style={{
						flex: '0 1 auto',
						margin: ' 0 16px 0 0',
						minWidth: '1px',
					}}
					data-testid='headerTitle__title'
				>
					<FlexGrid gap='tiny'>
						{isMobile && (
							<MovingGradient
								height='22px'
								width={getRandomBoundary(68, 120)}
							/>
						)}
						{!isMobile && (
							<>
								<MovingGradient
									height='22px'
									width={getRandomBoundary(50, 120)}
								/>
								<MovingGradient
									height='22px'
									width={getRandomBoundary(50, 170)}
								/>
								<MovingGradient
									height='22px'
									width={getRandomBoundary(40, 150)}
								/>
							</>
						)}
					</FlexGrid>
				</h2>
			</div>
		</section>
	);
};
